import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setReporter } from 'store/entities/submissions';
import { getInstitutionUsers } from 'store/entities/submissions/thunks';

import { Control, Label, Select } from 'components/UIComponents/Form';

const ReporterFilter = () => {
  const { institutionId } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    reporter,
    institutionUsers,
    institutionUsersLoading,
    submissionsListLoading,
  } = useSelector(state => state.submissions);

  const reporterOptions = useMemo(
    () =>
      institutionUsers.map(user => ({
        value: user,
        label: `${user?.publicUserDto?.firstName} ${user?.publicUserDto?.lastName}`,
      })),
    [institutionUsers]
  );

  useEffect(() => {
    if (institutionId) dispatch(getInstitutionUsers(institutionId));
  }, [institutionId, dispatch]);

  return (
    <Control>
      <Label htmlFor="reporterSelect">
        {t('datagate.external.submissions.filter.reporter.label')}
      </Label>
      <Select
        isDisabled={institutionUsersLoading || submissionsListLoading}
        isClearable={true}
        id="reporterSelect"
        placeholder={t(
          'datagate.external.submissions.filter.reporter.placeholder'
        )}
        options={reporterOptions}
        value={reporter}
        onChange={value => dispatch(setReporter(value))}
        ariaLabel="Reporter select"
      />
    </Control>
  );
};

export default ReporterFilter;
